<div class="cutom-aside-container d-felx flex-col justify-center align-items-center">
  <div class="aside-content">
    <mobi-office-lib-header-section [isMagicBellVisible]="false" [isProfileSettingVisible]="false"></mobi-office-lib-header-section>
    <div class="aside-tabs">
      @for (item of menuItems; track item) {
        <a class="aside-tab border-bottom-gray cursor-pointer" [matTooltip]="item.pageName || ''" matTooltipPosition="right" [ngClass]="{ active: isActiveRoute(item) }" (click)="onTabChange(item)">
          @if (item.isIcon) {
            @if (item.iconName) {
              <mat-icon class="aside-tab-icon {{ item.iconClass }}">{{ item?.iconName }}</mat-icon>
            }
          }
          @if (!item.isIcon) {
            <div class="aside-tab-icon {{ item.iconClass }}" [innerHtml]="(isActiveRoute(item) ? item?.selectedSvgIcon : item.defaultSvgIcon) | sanitizer: 'html'"></div>
          }
          @if (item.pageName) {
            <span class="aside-tab-text">{{ item.pageName }}</span>
          }
        </a>
      }
    </div>
  </div>
</div>
